<script>
import Titre from "@/components/atoms/titre";

export default {
  components: {
    Titre
  },
  props: {
    planning: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  methods: {
    allEqual(days) {
      return days.every(
        (val) =>
          val.dates[0].from === days[0].dates[0].from &&
          val.dates[0].to === days[0].dates[0].to
      );
    }
  },
  computed: {
    weekDays() {
      const weekendNum = [0, 6];
      const otherDays = [1, 2, 3, 4, 5];
      const otherDaysPlaning = [];
      const weekendPlaning = [];
      this.planning.forEach((day) => {
        if (otherDays.includes(day.jour_numero)) {
          otherDaysPlaning.push(day);
        }
        if (weekendNum.includes(day.jour_numero)) {
          weekendPlaning.push(day);
        }
      });
      otherDaysPlaning.sort((a, b) => a.jour_numero - b.jour_numero);
      weekendPlaning.sort((a, b) => a.jour_numero - b.jour_numero);
      return { otherDaysPlaning, weekendPlaning };
    }
  }
};
</script>
<template>
  <div class="u-flex-item-fluid u-mr-xxlg u-mr-none@sm u-mb-lg25@sm">
    <Titre
      tag="p"
      size="sm"
      class="u-mb-sm"
    >
      Horaires du Click & Collect
    </Titre>
    <template v-if="weekDays.otherDaysPlaning.length>1">
      <div
        v-if="allEqual(weekDays.otherDaysPlaning)"
        class="u-flex u-flex-column@sm u-flex-justify-between u-mb-sm"
      >
        <p class="u-mb-xxs">
          Du Lundi au vendredi
        </p>
        <p>
          {{ weekDays.otherDaysPlaning[1].dates[0].from }}- {{ weekDays.otherDaysPlaning[1].dates[0].to }}
          <template v-if="weekDays.otherDaysPlaning[1].dates.length >1 ">
            <br>
            {{ weekDays.otherDaysPlaning[1].dates[1].from }}- {{ weekDays.otherDaysPlaning[1].dates[1].to }}
          </template>
        </p>
      </div>
      <template
        v-for="(item,index) in weekDays.otherDaysPlaning"
        v-else
      >
        <div
          v-if="item.jour && item.dates.length>0"
          :key="index+item.jour"
          class="u-flex u-flex-column@sm u-flex-justify-between u-mb-sm"
        >
          <p
            v-if="item.jour"
            class="u-mb-xxs"
          >
            {{ item.jour }}
          </p>
          <p v-if="item.dates[0].from &&item.dates[0].to">
            {{ item.dates[0].from }}- {{ item.dates[0].to }}
            <template v-if="item.dates.length >1 ">
              <br>
              {{ item.dates[1].from }}- {{ item.dates[1].to }}
            </template>
          </p>
        </div>
      </template>
    </template>
    <template v-if="weekDays.weekendPlaning.length>0">
      <div
        v-if="allEqual(weekDays.weekendPlaning) && weekDays.weekendPlaning.length === 2 "
        class="u-flex u-flex-column@sm u-flex-justify-between u-mb-sm"
      >
        {{ weekDays.weekendPlaning }}
        <p class="u-mb-xxs">
          Du Samedi au dimanche
        </p>
        <p>
          {{ weekDays.weekendPlaning[0].dates[0].from }}- {{ weekDays.weekendPlaning[0].dates[0].to }}
          <template v-if=" weekDays.weekendPlaning[0].dates.length > 1 ">
            <br>
            {{ weekDays.weekendPlaning[0].dates[1].from }}- {{ weekDays.weekendPlaning[0].dates[1].to }}
          </template>
        </p>
      </div>
      <template
        v-for="(item,index) in weekDays.weekendPlaning"
        v-else
      >
        <div
          v-if="item.jour && item.dates.length>0"
          :key="index"
          class="u-flex u-flex-column@sm u-flex-justify-between u-mb-sm"
        >
          <p
            v-if="item.jour"
            :key="index+item.jour"
            class="u-mb-xxs"
          >
            {{ item.jour }}
          </p>
          <p
            v-if="item.dates[0].from && item.dates[0].to "
            :key="index+item.dates[0].from"
          >
            {{ item.dates[0].from }}- {{ item.dates[0].to }}
            <template v-if="item.dates.length >1 ">
              <br>
              {{ item.dates[1].from }}- {{ item.dates[1].to }}
            </template>
          </p>
        </div>
      </template>
    </template>
  </div>
</template>

<style lang="scss" scoped>
</style>
